import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[appRoutedTab]',
  standalone: true,
})
export class TabDirective {
  @HostBinding('class') get classes() {
    return this.active
      ? 'border-primary text-primary whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
      : 'border-transparent text-fg-secondary hover:text-fg-subtle hover:border-edge-strong whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm';
  }

  @Input()
  active = false;
}
